export const TRIP_TOTAL_TEXT = "Trip total";
export const CHECKOUT_PRICE_BREAKDOWN_HEADER = "Checkout Breakdown";
